module.exports = __webpack_public_path__ + "static/img/video-img.f146fa49.png";